module.exports = __webpack_public_path__ + "static/img/cas.7aca0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cas.png
// module id = ILGs
// module chunks = 1